import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import type { ReactElement, ReactNode } from 'react';
import React from 'react';

import { Image } from 'src/shared/components';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

import houseImageAvif from 'assets/img/house-split.avif';
import houseImage from 'assets/img/house-split.png';
import houseImageWebP from 'assets/img/house-split.webp';

import { Aside } from '../Aside';

export interface ContainerProps extends BoxProps {
  children: ReactNode;
  image?: ReactElement;
}

const Container = ({
  children,
  image: passedImage,
  ...props
}: ContainerProps) => {
  const t = useTranslate(TranslationNamespace.LOGIN);
  const image = passedImage || (
    <Image
      alt={t('aRenderedImageOfAHouse')}
      avif={houseImageAvif}
      src={houseImage}
      webp={houseImageWebP}
    />
  );

  return (
    <Box
      flex="1"
      flexDirection={{ base: 'column', tablet: 'row' }}
      justifyContent="flex-start"
      {...props}
    >
      <Box
        alignSelf="center"
        display="grid"
        flex={{ base: 0, tablet: 1 }}
        gridRowGap={400}
        justifyContent="stretch"
        justifyItems="center"
        marginX={600}
        marginY={{ base: 0, tablet: 600 }}
        order="1"
        position="relative"
      >
        {children}
      </Box>
      {image?.type === Aside ? (
        image
      ) : (
        <Aside
          display={{ base: 'none', tablet: 'flex' }}
          paddingRight={600}
          paddingY={600}
        >
          {image}
        </Aside>
      )}
    </Box>
  );
};

export { Container };
